import React from "react";
import searchbarIcon from "@/assets/img/reporting-search-bar-logo.svg";

const SearchBoxComponent = ({ searchQuery, setSearchQuery }) => {
  return (
    <div style={{ marginBottom: "6px", width: "42%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #EDEFF2",
          borderRadius: "5px",
          padding: "10px",
          backgroundColor: "#fff",
        }}
      >
        <img
          src={searchbarIcon}
          alt="Search"
          style={{
            marginRight: "10px",
          }}
        />
        <input
          type="text"
          placeholder="Search by Report Name, or Grouped By"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            border: "none",
            outline: "none",
            fontSize: "13px",
            color: searchQuery ? "#000000" : "#ADB5BD",
            width: "100%",
            fontWeight: 400
          }}
        />
      </div>
    </div>
  );
};

export default SearchBoxComponent;
